"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var selfCheck_exports = {};
__export(selfCheck_exports, {
  selfCheckBlock: () => selfCheckBlock,
  selfCheckField: () => selfCheckField,
  selfCheckForm: () => selfCheckForm,
  selfCheckPage: () => selfCheckPage
});
module.exports = __toCommonJS(selfCheck_exports);
var import_guard = require("@cartographerio/guard");
var import_topo_core = require("@cartographerio/topo-core");
var import_topo_survey = require("@cartographerio/topo-survey");
var import_util = require("@cartographerio/util");
var import_lodash = require("lodash");
var import_nullable = require("./nullable.js");
function isSelectSchema(options) {
  const normalize = (values) => (0, import_lodash.sortedUniq)((0, import_lodash.sortBy)(values, (x) => x));
  const isEnum = (schema, options2) => schema.type === "Enum" && (0, import_lodash.isEqual)(normalize(schema.values), normalize(options2.map((option) => option.value)));
  const isNullableEnum = (schema, options2) => schema.type === "Nullable" && (isEnum(
    schema.param,
    options2.filter((o) => o.value != null)
  ) || isNullableEnum(
    schema.param,
    options2.filter((o) => o.value != null)
  ));
  const isAllString = (schema) => options.every((option) => (0, import_guard.isNullable)(import_guard.isString)(option.value)) && (0, import_topo_survey.isMaybeNullableSchema)(import_topo_survey.isStringSchema)(schema);
  const isAllInteger = (schema) => options.every((option) => (0, import_guard.isNullable)(import_guard.isInteger)(option.value)) && (0, import_topo_survey.isMaybeNullableSchema)(import_topo_survey.isIntegerSchema)(schema);
  const isAllNumeric = (schema) => options.every((option) => (0, import_guard.isNullable)(import_guard.isNumber)(option.value)) && (0, import_topo_survey.isMaybeNullableSchema)(import_topo_survey.isNumberSchema)(schema);
  const isAllBoolean = (schema) => options.every((option) => (0, import_guard.isNullable)(import_guard.isBoolean)(option.value)) && (0, import_topo_survey.isMaybeNullableSchema)(import_topo_survey.isBooleanSchema)(schema);
  return (schema) => isEnum(schema, options) || isNullableEnum(schema, options) || isAllString(schema) || isAllInteger(schema) || isAllNumeric(schema) || isAllBoolean(schema);
}
const formatSelectOptions = (options) => options.map((o) => o.value).join(", ");
const fieldTypeName = (field, name) => (0, import_nullable.fieldIsNullable)(field) ? `nullable ${name}` : `maybe nullable ${name}`;
const fieldPredicate = (field, pred) => (schema) => (0, import_nullable.fieldIsNullable)(field) ? (0, import_topo_survey.isNullableSchema)(pred)(schema) : (0, import_topo_survey.isMaybeNullableSchema)(pred)(schema);
function check(path, formSchema, schema, expected, pred) {
  const pathString = (0, import_topo_core.pathToString)(path);
  if (schema == null) {
    return [
      (0, import_topo_core.errorMessage)(`${formSchema.type} at ${pathString} expects schema of type: ${expected}, found nothing`, path)
    ];
  } else {
    return pred(schema) ? [] : [
      (0, import_topo_core.errorMessage)(
        `${formSchema.type} at ${pathString} expects schema of type: ${expected}, found ${(0, import_topo_survey.describeSchema)(schema)}`,
        path
      )
    ];
  }
}
function selfCheckField(field, path0, schema) {
  const path = [...path0, ...field.path];
  switch (field.type) {
    case "TextField":
    case "TextArea":
    case "Autocomplete": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "string"),
        fieldPredicate(field, import_topo_survey.isStringSchema)
      );
    }
    case "IntegerField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "integer"),
        fieldPredicate(field, import_topo_survey.isNumericSchema)
      );
    }
    case "NumberField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "number"),
        fieldPredicate(field, import_topo_survey.isNumberSchema)
      );
    }
    case "UserRefField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "user reference"),
        fieldPredicate(field, import_topo_survey.isUserRefSchema)
      );
    }
    case "TimestampField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "timestamp"),
        fieldPredicate(field, import_topo_survey.isTimestampSchema)
      );
    }
    case "AttachmentField": {
      return check(path, field, (0, import_topo_survey.schemaRef)(schema, path), "attachment folder", import_topo_survey.isAttachmentFolderSchema);
    }
    case "PointField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "point"),
        fieldPredicate(field, (0, import_topo_survey.isGeometrySchema)("Point"))
      );
    }
    case "LineStringField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "line string"),
        fieldPredicate(field, (0, import_topo_survey.isGeometrySchema)("LineString"))
      );
    }
    case "PolygonField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "polygon"),
        fieldPredicate(field, (0, import_topo_survey.isGeometrySchema)("Polygon"))
      );
    }
    case "FeatureField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "feature"),
        fieldPredicate(field, (0, import_topo_survey.isFeatureSchema)())
      );
    }
    case "NearestFeatureField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "picked feature"),
        fieldPredicate(field, (0, import_topo_survey.isPickedSchema)())
      );
    }
    case "Checkbox": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "possibly nullable boolean"),
        (0, import_topo_survey.isMaybeNullableSchema)(import_topo_survey.isBooleanSchema)
      );
    }
    case "Select": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, `enum value (${formatSelectOptions(field.options)})`),
        isSelectSchema(field.options)
      );
    }
    case "MultiSelect": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        `array of enum values (${formatSelectOptions(field.options)})`,
        (0, import_topo_survey.isMaybeNullableSchema)((0, import_topo_survey.isArraySchema)(isSelectSchema(field.options)))
      );
    }
    case "TeamField": {
      return check(
        path,
        field,
        (0, import_topo_survey.schemaRef)(schema, path),
        fieldTypeName(field, "team id"),
        fieldPredicate(field, import_topo_survey.isUuidSchema)
      );
    }
    default:
      return (0, import_util.checkExhausted)(field);
  }
}
function selfCheckBlock(block, path, schema) {
  switch (block.type) {
    case "Heading":
    case "Text":
    case "DynamicValue":
    case "DynamicGrid":
    case "DynamicImage":
    case "PrimarySurveyorField":
    case "PrimaryTeamField":
      return [];
    case "Group":
      return block.blocks.flatMap((b) => selfCheckBlock(b, path, schema));
    case "Repeat": {
      const arrayPath = (0, import_topo_core.appendPath)(path, block.path);
      const arraySchema = (0, import_topo_survey.schemaRef)(schema, arrayPath);
      if ((0, import_topo_survey.isSchema)(arraySchema) && (0, import_topo_survey.isArraySchema)(import_topo_survey.isAnySchema)(arraySchema)) {
        return selfCheckBlock(block.block, (0, import_topo_core.appendPath)(arrayPath, 0), schema);
      } else {
        return check(path, block, arraySchema, `array`, (0, import_topo_survey.isArraySchema)(import_topo_survey.isSchema));
      }
    }
    case "Card":
    case "FullWidth":
    case "Visibility":
    case "RequireRole":
      return selfCheckBlock(block.block, path, schema);
    case "Scope":
      return selfCheckBlock(block.block, (0, import_topo_core.appendPath)(path, block.path), schema);
    default:
      return selfCheckField(block, path, schema);
  }
}
function selfCheckPage(page, path0, schema) {
  const path = [...path0, ...page.path];
  return (0, import_lodash.flatMap)(page.blocks, (block) => selfCheckBlock(block, path, schema));
}
function selfCheckForm(form, schema) {
  return (0, import_lodash.flatMap)(form.pages, (page) => selfCheckPage(page, [], schema));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  selfCheckBlock,
  selfCheckField,
  selfCheckForm,
  selfCheckPage
});
//# sourceMappingURL=selfCheck.js.map
